<template>
  <form ref="form" :action="lookupUrl" method="GET">
    <input type="hidden" name="location_query" :value="searchQuery">
    <input v-for="extraParam in extraParameterPairs" :key="extraParam.name" type="hidden" :name="extraParam.name" :value="extraParam.value">
    <input v-if="searchBiasCountry" type="hidden" name="user_country" :value="searchBiasCountry">
    <search-bar :initial-query="initialLocationQuery" :custom-placeholder-text="customPlaceholderText" @search="search">
      <template #search-button>
        <button type="submit" class="btn btn-lg btn-dark search-button" :title="searchButtonText">
          {{ searchButtonText }}
        </button>
      </template>
    </search-bar>
    <div v-if="distanceHint" class="text-start mt-1">
      <span class="small-text">
        {{ distanceHint }}
      </span>
    </div>
  </form>
</template>

<script>
import SearchBar from '@/local/search-bar'
import { locationSearchMixin } from '@/location-search/location-search-mixin'

export default {
  components: { SearchBar },

  mixins: [ locationSearchMixin ]
}
</script>

<style lang="scss" scoped>
.search-button {
  border-radius: 0 4px 4px 0;
}
</style>
